/**
 * IndexedDB Configuration for mevolve-connect
 *
 * IMPORTANT: When modifying this config:
 * 1. Increment the version number
 * 2. Add a migration for the new version
 * 3. Test with fresh install AND upgrade scenarios
 *
 * The database currently stores only 'emails' - all other collections
 * are managed via FirestoreStoreService with real-time listeners.
 */
export const dbConfig = {
  name: 'mevolveConnectDb',
  version: 3, // Incremented to trigger migration and ensure clean state
  objectStoresMeta: [
    {
      store: 'emails',
      storeConfig: { keyPath: 'id', autoIncrement: false },
      storeSchema: [{ name: 'id', keypath: 'id', options: { unique: true } }],
    },
  ],
  migrationFactory: () => {
    return {
      1: (db: IDBDatabase, transaction: IDBTransaction) => {
        // Migration from version 1 to 2: ensure emails store exists
        if (!db.objectStoreNames.contains('emails')) {
          db.createObjectStore('emails', {
            keyPath: 'id',
            autoIncrement: false,
          });
        }
      },
      2: (db: IDBDatabase, transaction: IDBTransaction) => {
        // Migration from version 2 to 3: cleanup invalid stores
        // Remove 'users' store if it exists (was never properly defined)
        if (db.objectStoreNames.contains('users')) {
          db.deleteObjectStore('users');
        }
        // Ensure emails store exists
        if (!db.objectStoreNames.contains('emails')) {
          db.createObjectStore('emails', {
            keyPath: 'id',
            autoIncrement: false,
          });
        }
      },
    };
  },
};
